import {FileConfig} from 'web-library';
import {AxiosError} from 'axios';
import {GET_REQUEST_FILE_CONFIGS_QUERY_KEY} from 'web-library/constants/queryKeys';
import {GET_REQUEST_FILE_CONFIGS_URL} from 'web-library/constants/apiUrls';
import axiosClient from '../axiosClient';
import {useCustomQuery} from '../utils/useCustomQuery';
import {GenericErrorResponse} from "../typings";

interface Input {
  onSuccess?: () => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const useGetRequestFileConfigs = ({onError, onSuccess}: Input) => {
  const getRequestFilesConfig = async () => {
    const res = await axiosClient.get<FileConfig>(GET_REQUEST_FILE_CONFIGS_URL());

    return res.data;
  };

  return useCustomQuery(GET_REQUEST_FILE_CONFIGS_QUERY_KEY, getRequestFilesConfig, {
    onSuccess,
    onError,
  });
};
